<template>
    <div>
        <div v-for="(item,index) in headList" :key="item.column_name">
            <el-table-column v-if="item.column_name === '_xh'||item.type === '_dx'"
                             type="selection"
                             fixed="left"
                             :width="item.column_width"
                             :key="index">
            </el-table-column>
            <el-table-column v-else-if="item.column_name === '_px'||item.type === '_px'"
                             type="index"
                             :index="(pageInfo.page-1) * pageInfo.pagesize+(index+1)"
                             fixed="left"
                             :label="item.column_comment"
                             :width="item.column_width"
                             :key="index">
            </el-table-column>
            <el-table-column v-else-if="item.column_name === '_opt'"
                             :label="item.column_comment"
                             :width="item.column_width"
                             :key="index">
                <template slot-scope="scope">
                    <template v-for="(opt,optIndex) in item.opts">
                        <template v-if="opt.model_key">
                            <el-button v-if="opt.model_val == scope.row[opt.model_key]"
                                       :key="optIndex"
                                       @click="tableOpt(opt.method,scope.row)"
                                       size="medium"
                                       :type="opt.type"
                                       :icon="opt.icon">{{opt.name}}
                            </el-button>
                        </template>
                        <template v-else>
                            <el-button :key="optIndex"
                                       @click="tableOpt(opt.method,scope.row)"
                                       size="medium"
                                       :type="opt.type"
                                       :icon="opt.icon">{{opt.name}}
                            </el-button>
                        </template>
                    </template>
                </template>
            </el-table-column>

            <el-table-column v-else-if="item.visible === undefined ? true : item.visible"
                             :prop="item.column_name"
                             :label="item.column_comment"
                             :width="item.column_width"
                             :key="index">
                <template slot-scope="scope">
                    <div v-if="item.type === 'hover'">
                        <el-popover trigger="click" placement="top" v-if="scope.row[item.column_name]">
                            <p style="text-align: center">{{scope.row[item.column_name]}}</p>
                            <div slot="reference" class="name-wrapper">
                                <el-tag size="medium">{{ scope.row[item.column_name] }}</el-tag>
                            </div>
                        </el-popover>
                    </div>

                    <div v-else-if="item.type === 'tag'">
                        <template v-for="info in item.info">
                            <template v-if="info.otherKey">
                                <template v-if="scope.row[info.otherKey] == info.otherCode">
                                    <el-tag v-if="scope.row[item.column_name] == info.code" :type="info.otherType" effect="dark"
                                            :key="info.code">
                                        {{info.otherName}}
                                    </el-tag>
                                </template>
                                <template v-else>
                                    <el-tag v-if="scope.row[item.column_name] == info.code" :type="info.type" effect="dark"
                                            :key="info.code">
                                        {{info.name}}
                                    </el-tag>
                                </template>
                            </template>
                            <template v-else>
                                <el-tag v-if="scope.row[item.column_name] == info.code" :type="info.type" effect="dark"
                                        :key="info.code">
                                    {{info.name}}
                                </el-tag>
                            </template>
                        </template>
                    </div>


                    <div v-else-if="item.type === 'clomn'">
                        <template v-for="info in item.info">
                            <div v-if="scope.row[item.column_name] == info.code" :key="info.code">
                                {{info.name}}
                            </div>
                        </template>
                    </div>

                    <div v-else-if="item.type === 'custom'">
                        <exSlot :render="item.render" :row="scope.row"/>
                    </div>


                    <div v-else>
                        <span v-if="item.prepend">{{item.prepend}}</span>
                        <span>{{scope.row[item.column_name]}}</span>
                        <span v-if="item.append">{{item.append}}</span>
                    </div>
                </template>
            </el-table-column>
        </div>
    </div>
</template>

<script>
    // 自定义内容的组件
    var exSlot = {
        functional: true,
        props: {
            row: Object,
            render: Function,
            index: Number,
            column: {
                type: Object,
                default: null
            }
        },
        render: (h, data) => {
            return data.props.render(h, data.props.row)
            // return (
            //     <div>111</div>
            // );
            // return data.props.render(h)
        }
    }
    export default {
        name: "tableColumn",
        props: {
            headList: {
                type: Array,
                default: () => []
            },
            pageInfo: {
                type: Object,
                default: () => ({
                    page: 1,
                    pagesize: 20,
                    pageSizes: [10, 20, 50, 100],
                    total: 0,
                })
            },
        },
        components: {exSlot},
        data() {
            return {}
        },
        // render(createElement, context) {
        //
        // },
        mounted() {
        },
        methods: {
            tableOpt(type, row) {
                this.$emit('tableOpt', type, row)
            }
        }
    }
</script>

<style scoped>
</style>
